import React from 'react'

export const ImportantSignIcon: React.FC = () => (
	<svg
		id='Group_4682'
		data-name='Group 4682'
		xmlns='http://www.w3.org/2000/svg'
		width='19.81'
		height='19.81'
		className='importantsignicon-svg'
		viewBox='0 0 19.815 19.815'>
		<g id='_003-info' data-name='003-info'>
			<g id='Group_4527' data-name='Group 4527'>
				<g id='Group_4526' data-name='Group 4526'>
					<rect
						id='Rectangle_107'
						data-name='Rectangle 107'
						width='1.981'
						height='5.944'
						transform='translate(8.917 8.917)'
						fill='#fff'
					/>
					<path
						id='Path_3398'
						data-name='Path 3398'
						d='M9.907,0a9.907,9.907,0,1,0,9.907,9.907A9.9,9.9,0,0,0,9.907,0Zm0,17.833a7.926,7.926,0,1,1,7.926-7.926A7.936,7.936,0,0,1,9.907,17.833Z'
						fill='#fff'
					/>
					<rect
						id='Rectangle_108'
						data-name='Rectangle 108'
						width='1.981'
						height='1.981'
						transform='translate(8.917 4.954)'
						fill='#fff'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export const ColorPickerIcon: React.FC = () => (
	<svg
		id='color'
		xmlns='http://www.w3.org/2000/svg'
		width='62.71'
		height='62.69'
		className='colorpickericon-svg'
		viewBox='0 0 62.709 62.688'>
		<path
			id='Path_3512'
			data-name='Path 3512'
			d='M229.7,236.461a1.842,1.842,0,0,1,0,2.6l-2.6,2.6a1.819,1.819,0,0,1-2.6,0,1.842,1.842,0,0,1,0-2.6l2.6-2.6A1.866,1.866,0,0,1,229.7,236.461Z'
			transform='translate(-196.542 -207.049)'
			fill='#d9d9d9'
		/>
		<path
			id='Path_3513'
			data-name='Path 3513'
			d='M233.543,240.229a1.842,1.842,0,0,1,0,2.6l-2.6,2.6a1.819,1.819,0,0,1-2.6,0Z'
			transform='translate(-200.381 -210.817)'
			fill='#c8c6cd'
		/>
		<path
			id='Path_3514'
			data-name='Path 3514'
			d='M14.691,238.575l-7.5-2.3L0,238.575a31.7,31.7,0,0,0,9.154,22.31l8.751.125L19.537,250.5A17.059,17.059,0,0,1,14.691,238.575Z'
			transform='translate(0 -207.35)'
			fill='#54e360'
		/>
		<path
			id='Path_3515'
			data-name='Path 3515'
			d='M241.219,354.794l-8.06-2.4a16.766,16.766,0,0,1-11.8,4.846l-4.821,9.641,4.821,5.05a31.411,31.411,0,0,0,22.188-9.154Z'
			transform='translate(-190.014 -309.246)'
			fill='#fdbf00'
		/>
		<path
			id='Path_3516'
			data-name='Path 3516'
			d='M365.355,78.514a.036.036,0,0,0-.037-.037A28.91,28.91,0,0,0,362.38,75.1l-6.235.842-4.2,9.552a16.122,16.122,0,0,1,4.885,11.643l10.024,4.438,4.667-4.438C371.526,89.2,368.043,81.2,365.355,78.514Z'
			transform='translate(-308.843 -65.911)'
			fill='#e61e14'
		/>
		<path
			id='Path_3517'
			data-name='Path 3517'
			d='M96.927.128A31.411,31.411,0,0,0,74.739,9.282s.564,7.986.028,8.522,10.355,1.862,10.355,1.862a16.766,16.766,0,0,1,11.8-4.846l5.126-6.274Z'
			transform='translate(-65.585 -0.123)'
			fill='#3aaaff'
		/>
		<path
			id='Path_3518'
			data-name='Path 3518'
			d='M19.538,85.251,9.154,74.868A31.122,31.122,0,0,0,0,96.933H14.691A16.476,16.476,0,0,1,19.538,85.251Z'
			transform='translate(0 -65.709)'
			fill='#00cc71'
		/>
		<path
			id='Path_3519'
			data-name='Path 3519'
			d='M357.114,255.021a17.059,17.059,0,0,1-4.846,11.926l10.383,10.383a31.7,31.7,0,0,0,9.154-22.31Z'
			transform='translate(-309.122 -223.797)'
			fill='#fd4e26'
		/>
		<path
			id='Path_3520'
			data-name='Path 3520'
			d='M85.123,352.4,74.74,362.779a31.411,31.411,0,0,0,22.188,9.154V357.242A16.766,16.766,0,0,1,85.123,352.4Z'
			transform='translate(-65.586 -309.246)'
			fill='#ffd400'
		/>
		<path
			id='Path_3521'
			data-name='Path 3521'
			d='M278.089,9.31,267.658,19.7a13.928,13.928,0,0,0-2.534-2.13l-.037-.037a16.721,16.721,0,0,0-9.194-2.718V.128A31.066,31.066,0,0,1,278.089,9.31Z'
			transform='translate(-224.551 -0.123)'
			fill='#0095ff'
		/>
		<path
			id='Path_3522'
			data-name='Path 3522'
			d='M251.066,92.011l-10.537,10.414L238.01,105a5.443,5.443,0,0,0-.026,7.765l.026.026a5.619,5.619,0,0,0,7.888-.026L258.857,99.8l-3.87-3.922-3.87-3.87Z'
			transform='translate(-207.419 -80.752)'
			fill='#d9d9d9'
		/>
		<path
			id='Path_3523'
			data-name='Path 3523'
			d='M373.454,2.231a7.3,7.3,0,0,1,2.156,5.22,7.4,7.4,0,0,1-4.077,6.571,25.842,25.842,0,0,0-7.142,5.064l-.052.052-3.87-3.922-3.9-3.9a26.807,26.807,0,0,0,5.116-7.142A7.342,7.342,0,0,1,373.454,2.231Z'
			transform='translate(-312.9 -0.088)'
			fill='#5a5a5a'
		/>
		<path
			id='Path_3524'
			data-name='Path 3524'
			d='M266.556,123.606l3.87,3.922-12.96,12.96a5.619,5.619,0,0,1-7.888.026l-.026-.026Z'
			transform='translate(-218.987 -108.478)'
			fill='#c8c6cd'
		/>
		<g
			id='Group_4695'
			data-name='Group 4695'
			transform='translate(40.54 2.143)'>
			<path
				id='Path_3525'
				data-name='Path 3525'
				d='M401.365,17.585a7.3,7.3,0,0,1,2.155,5.22,7.4,7.4,0,0,1-4.077,6.571A25.843,25.843,0,0,0,392.3,34.44l-.052.052-3.87-3.922Z'
				transform='translate(-381.352 -17.585)'
				fill='#444'
			/>
			<path
				id='Path_3526'
				data-name='Path 3526'
				d='M334.128,66.828l10.388,10.388a1.842,1.842,0,0,1,0,2.6,1.819,1.819,0,0,1-2.6,0L331.531,69.425a1.842,1.842,0,0,1,0-2.6A1.866,1.866,0,0,1,334.128,66.828Z'
				transform='translate(-330.996 -60.335)'
				fill='#444'
			/>
		</g>
		<path
			id='Path_3527'
			data-name='Path 3527'
			d='M380.375,113l5.194,5.194a1.842,1.842,0,0,1,0,2.6,1.819,1.819,0,0,1-2.6,0l-5.194-5.194Z'
			transform='translate(-331.508 -99.174)'
			fill='#2b292c'
		/>
	</svg>
)

export const UploadImageIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='72.35'
		height='57.41'
		className='uploadimageicon-svg'
		viewBox='0 0 72.354 57.409'>
		<defs>
			<linearGradient
				id='linear-gradient'
				x1='0.5'
				y1='1.47'
				x2='0.5'
				y2='0.382'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stopColor='#a5119f' />
				<stop offset='1' stopColor='#ff3067' />
			</linearGradient>
			<linearGradient
				id='linear-gradient-2'
				x1='0.5'
				x2='0.5'
				y2='1'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stopColor='#fff' />
				<stop offset='1' stopColor='#ff3067' />
			</linearGradient>
		</defs>
		<g id='upload' transform='translate(0 0)'>
			<g id='Group_4692' data-name='Group 4692' transform='translate(0 0)'>
				<path
					id='Path_3510'
					data-name='Path 3510'
					d='M59.494,73.395H42.536a2.119,2.119,0,0,1-2.12-2.12V62.8a2.119,2.119,0,0,1,2.12-2.12h2.12l-8.479-11.3L27.7,60.676h2.12a2.119,2.119,0,0,1,2.12,2.12v8.479a2.119,2.119,0,0,1-2.12,2.12H12.86a12.708,12.708,0,0,1-2.02-25.277A19.057,19.057,0,0,1,42.515,35.865a14.839,14.839,0,0,1,18.97,12.249,12.708,12.708,0,0,1-1.991,25.281Z'
					transform='translate(0 -31)'
					fill='url(#linear-gradient)'
				/>
			</g>
			<g
				id='Group_4694'
				data-name='Group 4694'
				transform='translate(21.338 12.766)'>
				<g id='Group_4693' data-name='Group 4693'>
					<path
						id='Path_3511'
						data-name='Path 3511'
						d='M180.25,139.1l-12.718-16.958a2.2,2.2,0,0,0-3.395,0L151.418,139.1a2.12,2.12,0,0,0,1.7,3.391h4.239v12.9a2.119,2.119,0,0,0,2.12,2.12h12.718a2.119,2.119,0,0,0,2.12-2.12v-12.9h4.239a2.12,2.12,0,0,0,1.7-3.391Zm-8.057,22.645H159.475a2.12,2.12,0,1,0,0,4.239h12.718a2.12,2.12,0,1,0,0-4.239Z'
						transform='translate(-150.995 -121.337)'
						fill='url(#linear-gradient-2)'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export const DragAndDropCloudIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='29.54'
		height='20.43'
		viewBox='0 0 29.541 20.429'>
		<g id='_1103496' data-name='1103496' transform='translate(0 0)'>
			<path
				id='Path_2830'
				data-name='Path 2830'
				d='M23.856,7.438A9.243,9.243,0,0,0,5.729,7.432a6.47,6.47,0,0,0,.745,12.9h4.621a.924.924,0,1,0,0-1.849H6.474a4.621,4.621,0,1,1,.055-9.242.924.924,0,0,0,.919-.822,7.394,7.394,0,0,1,14.69,0,.98.98,0,0,0,.973.822,4.621,4.621,0,1,1,0,9.243H18.489a.924.924,0,0,0,0,1.849H23.11a6.47,6.47,0,0,0,.746-12.891Zm0,0'
				transform='translate(0.001 0)'
				fill='#ff3067'
			/>
			<path
				id='Path_2831'
				data-name='Path 2831'
				d='M180.347,197.655a.924.924,0,0,0,1.33-1.284l-.023-.023-3.92-3.921a.924.924,0,0,0-1.307,0l0,0-3.92,3.921a.924.924,0,0,0,1.284,1.329l.023-.023,2.343-2.344V201.7a.924.924,0,1,0,1.848,0v-6.387Zm0,0'
				transform='translate(-162.287 -182.193)'
				fill='#ff3067'
			/>
		</g>
	</svg>
)

export const BrandNameColorIcon: React.FC = () => (
	<svg
		id='mozy'
		xmlns='http://www.w3.org/2000/svg'
		width='52.61'
		height='52.61'
		className='brandnamecoloricon-svg'
		viewBox='0 0 52.612 52.612'>
		<path
			id='Path_3528'
			data-name='Path 3528'
			d='M24.764,18.6A6.184,6.184,0,0,1,18.6,24.764H6.165A6.184,6.184,0,0,1,0,18.6V6.165A6.184,6.184,0,0,1,6.165,0H18.6a6.184,6.184,0,0,1,6.165,6.165Z'
			transform='translate(0 0)'
			fill='#ff3067'
		/>
		<path
			id='Path_3529'
			data-name='Path 3529'
			d='M295.764,289.6a6.184,6.184,0,0,1-6.165,6.165H277.165A6.184,6.184,0,0,1,271,289.6V277.165A6.184,6.184,0,0,1,277.165,271H289.6a6.184,6.184,0,0,1,6.165,6.165Z'
			transform='translate(-243.153 -243.153)'
			fill='#a5119f'
		/>
		<path
			id='Path_3530'
			data-name='Path 3530'
			d='M17.625,66.614a6.146,6.146,0,0,0,4.354,1.811H34.413a6.184,6.184,0,0,0,6.165-6.165V49.826a9.259,9.259,0,0,1,9.248-9.248H62.26a6.184,6.184,0,0,0,6.165-6.165V21.979a6.146,6.146,0,0,0-1.811-4.354H65.073L17.625,65.073Z'
			transform='translate(-15.814 -15.814)'
			fill='#3b2a82'
		/>
		<path
			id='Path_3531'
			data-name='Path 3531'
			d='M46.446,0H34.013a6.184,6.184,0,0,0-6.165,6.165V18.6A9.259,9.259,0,0,1,18.6,27.847H6.165A6.184,6.184,0,0,0,0,34.013V46.446A6.146,6.146,0,0,0,1.811,50.8L50.8,1.811A6.146,6.146,0,0,0,46.446,0Z'
			transform='translate(0 0)'
			fill='#442e9f'
		/>
	</svg>
)

export const PlusIcon: React.FC = () => (
	<svg
		id='_001-add'
		data-name='001-add'
		xmlns='http://www.w3.org/2000/svg'
		width='20.07'
		height='20.07'
		className='plusicon-svg'
		viewBox='0 0 20.075 20.074'>
		<g id='Group_4463' data-name='Group 4463'>
			<path
				id='Path_3369'
				data-name='Path 3369'
				d='M18.976,8.471h-7.37V1.114A1.109,1.109,0,0,0,10.51,0H9.567a1.111,1.111,0,0,0-1.1,1.112V8.471H1.1A1.1,1.1,0,0,0,0,9.566v.949a1.1,1.1,0,0,0,1.1,1.093H8.469v7.384a1.088,1.088,0,0,0,1.1,1.085h.943a1.087,1.087,0,0,0,1.1-1.085V11.608h7.37a1.1,1.1,0,0,0,1.1-1.093V9.566A1.1,1.1,0,0,0,18.976,8.471Z'
				transform='translate(0 -0.002)'
				fill='#fff'
			/>
		</g>
	</svg>
)

interface CrossIconI {
	onClick?: () => void
}

export const CrossIcon: React.FC<CrossIconI> = ({ onClick }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='34'
			height='34'
			onClick={onClick}
			className='crossicon-svg'
			viewBox='0 0 34 34'>
			<g
				id='Group_4817'
				data-name='Group 4817'
				transform='translate(-1698 -494)'>
				<rect
					id='Rectangle_168'
					data-name='Rectangle 168'
					width='34'
					height='34'
					rx='10'
					transform='translate(1698 494)'
					fill='#ff3067'
				/>
				<g
					id='_001-add'
					data-name='001-add'
					transform='translate(1715.473 524.406) rotate(-135)'>
					<g id='Group_4463' data-name='Group 4463'>
						<path
							id='Path_3369'
							data-name='Path 3369'
							d='M17.291,7.719H10.575v-6.7A1.011,1.011,0,0,0,9.577,0H8.717a1.012,1.012,0,0,0-1,1.013v6.7H1a1,1,0,0,0-1,1v.864a1,1,0,0,0,1,1H7.717v6.728a.992.992,0,0,0,1,.989h.859a.99.99,0,0,0,1-.989V10.577h6.716a1,1,0,0,0,1-1V8.717A1,1,0,0,0,17.291,7.719Z'
							transform='translate(0 -0.002)'
							fill='#fff'
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}
